var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.732 5.82h5.715v2.048h3.19V5.82h11.34v2.048h2.954V5.82h6.246v6.06H1.732V5.82z",
    fill: "#5333D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.718 5.462H11.194m-3.916 0H4.293a3 3 0 0 0-3 3v20.235a3 3 0 0 0 3 3H24.01m7.643-9.132V8.462a3 3 0 0 0-3-3h-3.195M1.293 11.88h30.36",
    stroke: "#35404A",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.148,
    y: 2.6,
    width: 3.916,
    height: 5.129,
    rx: 1.25,
    stroke: "#35404A",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.762,
    y: 14.953,
    width: 5.219,
    height: 5.338,
    rx: 1,
    fill: "#5333D4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.981,
    y: 14.953,
    width: 5.219,
    height: 5.338,
    rx: 1,
    fill: "#5333D4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 14.953,
    width: 5.219,
    height: 5.338,
    rx: 1,
    fill: "#5333D4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.762,
    y: 23.291,
    width: 5.219,
    height: 5.338,
    rx: 1,
    fill: "#5333D4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.564,
    y: 2.6,
    width: 3.916,
    height: 5.129,
    rx: 1.25,
    stroke: "#35404A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.694 23.48a6.038 6.038 0 1 0 2.152 2.27",
    stroke: "#35404A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.419 28.926.866.781c.48.433 1.233.332 1.583-.21l1.785-2.77",
    stroke: "#5333D4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m35.938 34.245 1.485 1.221M33.034 36.183l.237 1.909M37.28 31.021l1.92-.135",
    stroke: "#5333D4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7fe72790ac928072ab5553bec3856c6f.svg";
export { ForwardRef as ReactComponent };